export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI!,
  },
  cache: {
    cacheLocation: "localStorage", // or "sessionStorage"
    storeAuthStateInCookie: false,
  },
};

export const defaultMsalScopes = [
  import.meta.env.VITE_API_SCOPE || "",
  "User.Read",
].filter(Boolean);

export const loginRequest = {
  scopes: defaultMsalScopes,
};
